// External dependencies
import $ from 'jquery';

/**
 * @desc :- Calculate Dynamic mega menu width and position
 */
// function navDropdownWidthCalculate(timeout) {
//     const navbarContainer = $('nav .container');
//     const dropdownItem = $('nav .dropdown-parent');
//     // console.log(navbarContainer?.offset()?.left);
//     // console.log(dropdownItem?.offset()?.left);
//     // console.log(dropdownItem?.offset()?.left - navbarContainer?.offset()?.left);

//     // console.log(marginLeft);
//     $('nav .custom-dropdown').css('--custom-dropdown-width', navbarContainer?.innerWidth() - 100 + 'px');

//     setTimeout(() => {
//         const marginLeft = -(dropdownItem?.offset()?.left - navbarContainer?.offset()?.left - 50);
//         $('nav .custom-dropdown').css('--custom-dropdown-left', marginLeft + 'px');
//     }, timeout);

    
// }

// navDropdownWidthCalculate(1000);

// window.addEventListener(
//     'resize',
//     function (event) {
//         navDropdownWidthCalculate(200);
//         // console.log('resize');
//     },
//     true
// );

function getDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet =
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ||
        (/macintosh/.test(userAgent) && "ontouchend" in document);

    const isMobile = /mobile|iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/.test(userAgent) && !isTablet;
    const isDesktop = !isMobile && !isTablet;
    const isMobileOrTab = isMobile || isTablet;

    const isLandscape = window.matchMedia("(orientation: landscape)").matches;
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    return {
        isDesktop,
        isTablet,
        isMobile,
        isMobileOrTab,
        isLandscape,
        isPortrait,
        userAgent,
    };
}

function navDropdownWidthCalculate(timeout) {
    setTimeout(() => {
        const navbarContainer = $('nav .container');
        const dropdownItems = $('nav .dropdown-parent'); 
        const device = getDeviceType();

        dropdownItems.each(function() {
            const $dropdownItem = $(this);
            $dropdownItem.attr('data-is-tablet', `${device?.isTablet}`)
            $dropdownItem.attr('data-is-landscape', `${device?.isLandscape}`); 
            const $dropdownMenu = $dropdownItem.find('.custom-dropdown');
            const layout = Number($dropdownMenu.data('grid-layout'))
            $('nav .custom-dropdown').css('--custom-dropdown-width', navbarContainer?.innerWidth() - 100 + 'px');
            

            if ($dropdownMenu.length) {

                const dropdownWidth = $dropdownMenu.width();
                let marginLeft = Math.round($dropdownItem.offset().left - navbarContainer.offset().left) - 50;
                
               
                if (device?.isDesktop) {
                    // console.log('inner condition');
                    if (dropdownWidth < 400) {
                        marginLeft -=  $dropdownItem.offset().left - navbarContainer.offset().left - 150;
                    } else if (dropdownWidth < 739) {
                        marginLeft -=  $dropdownItem.offset().left - navbarContainer.offset().left - 400;
                    }
                }

            //    console.log(device, 'device');
            //    console.log(marginLeft, 'marginleft');
            //    console.log($dropdownItem.offset().left, '$dropdownItem.offset().left');
            //    console.log(navbarContainer.offset().left, 'navbarContainer.offset().left');
            //    console.log($dropdownItem.offset().left - navbarContainer.offset().left, '$dropdownItem.offset().left - navbarContainer.offset().left');
            //    console.log(($dropdownItem.offset().left - navbarContainer.offset().left) - 50, '($dropdownItem.offset().left - navbarContainer.offset().left) - 50;');

                // Apply the margin to center-align the dropdown
                // if (layout === 2) {
                //     const centerWidth = dropdownWidth / 2;
                //     const dropOffsetRight = $(window).width() - $dropdownMenu.offset().left;
                //     if (Number(dropOffsetRight) > Number(centerWidth) + 50) $dropdownMenu.css('--custom-dropdown-left', `-${centerWidth}px`);
                //     else $dropdownMenu.css({
                //         left : 'initial',
                //         right : '0px'
                //     })
                // }
                // else $dropdownMenu.css('--custom-dropdown-left', `-${layout > 2 ? marginLeft : 0}px`);

                if (layout == 3) {
                    $dropdownMenu.css('--custom-dropdown-left', `-${ marginLeft}px`);
                } else {
                    const centerWidth = layout == 2 ? dropdownWidth / 2 : dropdownWidth;
                    const dropOffsetRight = $(window).width() - $dropdownItem.offset().left;

                    // console.log(dropOffsetRight, centerWidth, layout);
                    // console.log( $(window).width(), $dropdownItem.offset().left);

                    console.log(Number(dropOffsetRight) > Number(centerWidth) + 100);
                    if (Number(dropOffsetRight) > Number(centerWidth) + 100) $dropdownMenu.css('--custom-dropdown-left', `-${layout == 1 ? 0 : centerWidth}px`);
                
                    else $dropdownMenu.css({
                        left : 'initial',
                        right : '0px'
                    })
                }
            }
        });
    }, timeout);
}
// Initialize on load
navDropdownWidthCalculate(1000);

// Update on resize (debounced to avoid performance issues)
let resizeTimer;
$(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        // console.log('loggg')
        navDropdownWidthCalculate(300)
    }, 100);
});

/**
 * @desc :- mobile megamenu slider
 */
// const swiper = new Swiper('.mobile-megamenu-slider', {
//     slidesPerView: 1.15,
//     spaceBetween: 15,
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//     },
//     breakpoints: {
//         // when window width is >= 480px
//         480: {
//             slidesPerView: 1.5,
//         },
//         576: {
//             slidesPerView: 2,
//             spaceBetween: 20,
//         },
//         // when window width is >= 640px
//         768: {
//             slidesPerView: 2.5,
//             spaceBetween: 30,
//         },
//     },
// }); 
// wr

// swiper.on("slideChange", function ({ isEnd }) {
//     if (isEnd) {
//         swiper.params.slidesPerView = 1;
//         swiper.update();
//         swiper.setTransition(450);
//     } else {
//         if (swiper.params.slidesPerView === 1) {
//             swiper.params.slidesPerView = 1.35;
//             swiper.update();
//             swiper.setTransition(450);
//         }
//     }
// });

/**
 * @desc :- Dropdown auto hide prevent
 */
// $('nav .dropdown-menu').on( 'click', function (event) {
//     event.stopPropagation();
// });


/**
 * @desc :- Dropdown Link click go to next page
 */
$('nav a.dropdown-toggle').on('click', function (e) {
    e.preventDefault();

    // console.log('this.href', this.href);
    // location.href = this.href;

    const windowWidth = window.innerWidth;
    // console.log(windowWidth);
        location.href = this.href;

    // if (windowWidth > 991) {
    //     location.href = this.href;
    // }
});
 
// svg Toggling for Tab
$('nav span.dropdown-toggle svg').on('click', function(e){
    e.preventDefault();
    const device = getDeviceType();

    if (device?.isTablet) {
        const $dropdown = $(this).closest('.dropdown');
        const $navItemWrapper = $dropdown.find('.nav-item-wrapper');

        const isCurrentlyOpen = $dropdown.hasClass('open');

        // Close other open dropdowns
        $('.dropdown').not($dropdown).removeClass('open')
        .find('.nav-item-wrapper').removeClass('disable-hover');
        // Toggle the clicked dropdown
        // $dropdown.toggleClass('open');
        // $navItemWrapper.toggleClass('disable-hover');
        if (isCurrentlyOpen) {
            $dropdown.removeClass('open');
            $navItemWrapper.addClass('disable-hover'); // Disable hover when closed
        } else {
            $dropdown.addClass('open');
            $navItemWrapper.removeClass('disable-hover'); // Enable hover when opened
        }
    }
})

$(document).on('click', function(e){
    // e.preventDefault();
    const device = getDeviceType();

    if (device?.isTablet) {
        if ($(e.target).closest('.dropdown-parent')?.length <= 0) $('.dropdown').removeClass('open')
       
    }
})

// $(document).ready(function() {
//     // Toggle dropdown on SVG click (tablet only)
//     $('nav span.dropdown-toggle svg').on('click', function(e) {
//         e.preventDefault();
//         const device = getDeviceType();
        
//         if (device?.isTablet) {
//             // Get the parent dropdown element
//             const dropdown = $(this).closest('.dropdown');
//             const dropdownMenu = dropdown.find('.dropdown-menu');
            
//             // Close all other open dropdowns
//             $('.dropdown.open').not(dropdown).removeClass('open');
//             // .find('.dropdown-menu').removeClass('custom-dropdown');
              
//             // Toggle the clicked dropdown and remove custom-dropdown when closing
//             if (dropdown.hasClass('open')) {
//                 dropdown.removeClass('open');
//                 // dropdownMenu.removeClass('custom-dropdown');
//             } else {
//                 dropdown.addClass('open');
//                 // dropdownMenu.addClass('custom-dropdown');
//             }
           
//             // Toggle the clicked dropdown
//             // dropdown.toggleClass('open');
//         }
//     });
    
//     // Close dropdown when clicking elsewhere
//     $(document).on('click', function(e) {
//         if (!$(e.target).closest('.dropdown-parent').length) {
//             $('.dropdown.open').removeClass('open');
//                 // .find('.dropdown-menu').removeClass('custom-dropdown');
//         }
//     });
    
//     // Prevent dropdown close when clicking inside the dropdown menu
//     $('.dropdown-menu').on('click', function(e) {
//         e.stopPropagation();
//     });
// });

// wr


$('nav a.dropdown-toggle dropdown-toggle .text').on('click', function (e) {
    const windowWidth = window.innerWidth;
    // console.log(windowWidth);

    const link = $(this).parent().attr('href');
    // console.log(link);

    if (windowWidth < 992) {
        location.href = link;
    }
});

/**
 * @desc :- Toggle add remove class add in navbar and header
 */
$('.main-navbar .navbar-toggler').on('click', function (e) {
    // console.log('clicked');
    // console.log($(this).attr('class').split(/\s+/));
    // console.log($(this).hasClass('collapsed'));

    if (!$(this).hasClass('collapsed')) {
        // console.log('open');
        $('body').addClass('fix-height');

        $('header').css('overflow-y', 'scroll').css('min-height', 'calc(100vh - calc(100vh - 100%))');
    } else {
        $('body').removeClass('fix-height');

        $('header').css('overflow-y', 'initial').css('min-height', 'initial');
    }
});

/**
 * @desc :- Outside click Toggle hide
 */
$(document).on('click', function (event) {
    const mainNavbar = $('.navbar');

    const modalContent = $('.rt-contact-form-section.popup-form');

    if (modalContent.is(event.target) || modalContent.has(event.target).length !== 0) {
        return;
    }

    if (!mainNavbar.is(event.target) && mainNavbar.has(event.target).length === 0) {
        if ($('.navbar-collapse').hasClass('show')) {
            $('.navbar-toggler').click();
            $('body').removeClass('fix-height');
            $('header').css('overflow-y', 'initial').css('min-height', 'initial');
        }
    }
});

// Mobile Dropdown Menu

$(document).ready(function() {
    $('.navbar-nav .dropdown-toggle').on('click', function(e) {
        if (window.innerWidth <= 991) {  
            if ($(e.target).closest('.text').length) {
                return;
            }
            e.preventDefault();

            const toggle = $(this).closest('.dropdown-toggle');
            const menu = $(this).closest('.dropdown').find('.dropdown-menu');

            menu.slideToggle(200, function() {
                toggle.toggleClass('show');
            });
        }
    });
});


//  Sticky Header on Scroll

$(document).ready(function () {
    function handleStickyHeader() {
      const currentScroll = $(window).scrollTop();
      const $header = $(".rl-main-header");
      const toggleClass = "is-sticky";

      if (currentScroll > 150) {
        $header.addClass(toggleClass);
      } else {
        $header.removeClass(toggleClass);
      }
    }
    handleStickyHeader();
    $(window).on("scroll", handleStickyHeader);
});


// Top header country localized data

jQuery(document).ready(function($) {
    // Get the selected countries data from localized data
    const countryPhoneNumbers = window.RETO_ContactFormParams.selected_countries_data || {};
    const selectedCountries = Object.keys(countryPhoneNumbers);
    const $phoneLink = $('.dynamic-phone-number');
    const $flagImage = $('.rl-country-flag-image');
    const getFlagUrl = (countryCode, size = '24x18') => `https://flagcdn.com/${size}/${String(countryCode || '').toLowerCase()}.png`;
    
    // Detect user's country and handle the response
    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.RETO_ContactFormParams.ajax_url,
        data: {
            action: 'rul_get_country_code_action'
        },
        success: function(response) {
            if (response.status == 200) {
                const userCountry = response.country_code.toUpperCase();                
                // Check if we support this country
                if (selectedCountries.includes(userCountry)) {
                    const countryData = countryPhoneNumbers[userCountry] || {};
                    const phoneNumber = countryData.phone || '';
                    const flagCode = countryData.flag_code || '';

                    if (phoneNumber) {
                        $phoneLink.find('.phone-number-text, .call-now-number-text').text(phoneNumber);
                        $phoneLink.attr('href', 'tel:' + phoneNumber.replace(/\s+/g, ''));
                        $phoneLink.attr('aria-label', 'Call us at ' + phoneNumber);
                    }

                    if ($flagImage.length && flagCode) {
                        $flagImage.attr('src', getFlagUrl(flagCode, '24x18'));
                        $flagImage.attr('srcset', getFlagUrl(flagCode, '48x36') + ' 2x');
                        $flagImage.attr('alt', flagCode.toUpperCase());
                    }
                } 
            
            } 

        },

    });

    /******************** Search Feature ***************************/ 

    // Toggle search modal
    jQuery(document).ready(function($) {
        // Current page tracking
        var currentPage = 1;
        var currentQuery = '';
        var searchTimer;
        var currentRequest = null;

        // Toggle search modal and hide top header
        $('.js-search-toggle').on('click', function(e) {
            e.preventDefault();
            $('#search-modal').toggleClass('active').fadeToggle();
            
            if ($('#search-modal').hasClass('active')) {
                $('body').css('overflow', 'hidden');
                $('#rl-top-header').addClass('hidden');
                $('.search-query-input').focus();
            } else {
                $('body').css('overflow', 'auto');
                $('#rl-top-header').removeClass('hidden');
            }
        });
        
        // Close modal when clicking outside content
        // $('#search-modal').on('click', function(e) {
        //     if ($(e.target).is('#search-modal')) {
        //         $(this).fadeOut();
        //         $('body').css('overflow', 'auto');
        //         $('#rl-top-header').removeClass('hidden');
        //     }
        // });        
        // Handle search functionality
        $('.search-query-input').on('input', function() {
            var query = $(this).val().trim();
            currentPage = 1;
            
            clearTimeout(searchTimer);
            if (currentRequest) {
                currentRequest.abort();
                currentRequest = null;
            }
            
            if (query.length >= 1) {
                $('.search-body-messages-wrapper .hidden').addClass('hidden');
                $('.loading-icon').removeClass('hidden');
                $('.search-body').addClass('hidden');
                
                searchTimer = setTimeout(function() {
                    performSearch(query, currentPage);
                }, 500);
            } else {
                clearSearch();
            }
        });
        
        function clearSearch() {
            $('.loading-icon, .error-message, .no-results-message').addClass('hidden');
            $('.search-body').addClass('hidden');
            $('.results-list').empty();
            currentQuery = '';
        }
        
        function performSearch(query, page) {
            if (currentRequest) {
                currentRequest.abort();
            }
            
            currentRequest = $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'custom_search',
                    query: query,
                    page: page
                },
                beforeSend: function() {
                    currentQuery = query;
                    $('.loading-icon').removeClass('hidden');
                    $('.error-message, .no-results-message').addClass('hidden');
                },
                success: function(response) {
                    $('.loading-icon').addClass('hidden');
                    response.success ? displaySearchResults(response.data) : showNoResults();
                },
                error: function(xhr, status, error) {
                    if (status !== 'abort') {
                        $('.loading-icon').addClass('hidden');
                        $('.error-message').removeClass('hidden');
                    }
                },
                complete: function() {
                    currentRequest = null;
                }
            });
        }
        
        function displaySearchResults(data) {
            var $resultsList = $('.results-list').empty();
            
            if (data.results.length > 0) {
                // Update current page
                currentPage = data.pagination.current_page || 1;
                // Update current page

                // Update current page
                $('.pagination-info .current-pagination').text(data.pagination.current_range);
                $('.pagination-info .total-result-count').text(data.pagination.total);
                $('.pagination-info .search-criteria').text(data.query);
                
                // Add results to the list
                $.each(data.results, function(index, result) {
                    var highlightedTitle = result.title.replace(
                        new RegExp('(' + currentQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'),
                        '<em class="highlight">$1</em>'
                    );
                    
                    $resultsList.append(
                        $('<li>').append(
                            $('<a>').attr({
                                'href': result.link,
                                'target': '_blank',
                                'rel': 'noopener noreferrer'
                            }).append(
                                $('<h3 class="title">').html(highlightedTitle),
                                $('<span class="url">').text(result.link)
                            )
                        )
                    );
                });
                
                $('.previous-link').toggleClass('hidden', !data.pagination.prev_page)
                    .attr('data-page', data.pagination.prev_page || '');
                    
                $('.next-link').toggleClass('hidden', !data.pagination.next_page)
                    .attr('data-page', data.pagination.next_page || '');
                
                $('.search-body').removeClass('hidden');
            } else {
                showNoResults();
            }
        }
        
        function showNoResults() {
            if (currentQuery.length > 0) {
                $('.no-results-message').removeClass('hidden');
            }
            $('.search-body').addClass('hidden');
            $('.previous-link, .next-link').addClass('hidden');
        }
        
        // Single pagination handler
        $(document).on('click', '.previous-link, .next-link', function(e) {
            e.preventDefault();
            $('.search-body-messages-wrapper .hidden').addClass('hidden');
            $('.loading-icon').removeClass('hidden');
            $('.search-body').addClass('hidden');
            currentPage = $(this).attr('data-page');
            performSearch(currentQuery, currentPage);
        });

        $(document).on('click', '.try-again', function(e) {
            e.preventDefault();
            $('.search-body-messages-wrapper .hidden').addClass('hidden');
            $('.loading-icon').removeClass('hidden');
            $('.search-body').addClass('hidden');
            performSearch(currentQuery, currentPage);
        });
    });
    // end search
});

// Catergory on Blog page grid alignment -center

jQuery(document).ready(function ($) {
    function updateGridLayout() {
      const $grid = $('.blog-roll-2');
  
      // Get all blog-roll__item (including those previously moved into .center-row)
      let $allItems = $grid.find('.blog-roll__item-2');
  
      // Remove previous .center-row and move detached items back to grid
      $grid.find('.blog-center-row').remove();
      $grid.append($allItems); // restore to original layout
  
      // Recalculate based on screen width
      let itemsPerRow = 4;
      if (window.innerWidth <= 767) {
        itemsPerRow = 2;
      } else if (window.innerWidth <= 991) {
        itemsPerRow = 3;
      }
  
      const remainder = $allItems.length % itemsPerRow;
  
      if (remainder !== 0) {
        const $lastItems = $allItems.slice(-remainder);
        $lastItems.detach();
  
        const $centerRow = $('<div class="blog-center-row"></div>');
        $centerRow.append($lastItems);
        $grid.append($centerRow);
      }
    }
  
    // Initial layout
    updateGridLayout();
  
    // Recalculate layout on window resize — NO RELOAD
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateGridLayout, 200);
    });
  });
  

// Newsletter button

jQuery(document).ready(function ($) {
    $('.rul-newsletter-btn').on('click', function () {
        var modalId = $(this).data('modal'); // Get modal ID from button
        $('#' + modalId).fadeIn(); // Open corresponding modal
    });

    $('.rul-close-btn').on('click', function () {
        $(this).closest('.rul-newsletter-modal').fadeOut();
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.rul-newsletter-content, .rul-newsletter-btn').length) {
            $('.rul-newsletter-modal').fadeOut();
        }
    });
});

